import { render } from "./CadastrarEvento.vue?vue&type=template&id=68c2eb5c&scoped=true"
import script from "./CadastrarEvento.vue?vue&type=script&lang=js"
export * from "./CadastrarEvento.vue?vue&type=script&lang=js"

import "./CadastrarEvento.vue?vue&type=style&index=0&id=68c2eb5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c2eb5c"]])

export default __exports__